import { render, staticRenderFns } from "./ShippingAddFormRestricted.vue?vue&type=template&id=316cfe52"
import script from "./ShippingAddFormRestricted.vue?vue&type=script&lang=js"
export * from "./ShippingAddFormRestricted.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddFormRestricted.vue?vue&type=style&index=0&id=316cfe52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports